import React from 'react';
import PropTypes from 'prop-types';
import { renderImage, NFT_PROMO } from 'helpers/ImageHelper';
import Style from './Thumbnail.module.scss';

const Thumbnail = ({ image = '' }) => (
  <div className={Style.imageContainer}>
    <div className={Style.image}>
      {renderImage({
        className: Style.thumbnail,
        src: image,
        imageType: NFT_PROMO,
      })}
    </div>
  </div>
);

Thumbnail.propTypes = {
  image: PropTypes.string,
};

export default Thumbnail;
